import { render } from "./bmActivitySignInfo.vue?vue&type=template&id=5c63a5ba&scoped=true"
import script from "./bmActivitySignInfo.vue?vue&type=script&lang=js"
export * from "./bmActivitySignInfo.vue?vue&type=script&lang=js"

import "./bmActivitySignInfo.vue?vue&type=style&index=0&id=5c63a5ba&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c63a5ba"]])

export default __exports__